// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: 'Inter', sans-serif;
        }

        /* What We Offer Section */
        .what-we-do {
            padding: 80px 6vw 60px;
            background: linear-gradient(180deg, #0f1e2e 0%, #16293f 50%, #0f1e2e 100%);
            position: relative;
            overflow: hidden;
            min-height: 100vh;
            height: 100%;
            width: 100%;
            z-index: 1;
        }

        .what-wrap {
            max-width: 1200px;
            margin: auto;
            position: relative;
            z-index: 1;
            width: 100%;
        }

        .what-header {
            margin-bottom: 60px;
            max-width: 800px;
        }

        .eyebrow {
            display: inline-block;
            font-size: 14px;
            font-weight: 700;
            letter-spacing: 0.15em;
            text-transform: uppercase;
            color: var(--green);
            margin-bottom: 16px;
        }

        .what-header h2 {
            font-size: 48px;
            font-weight: 800;
            line-height: 1.2;
            margin-bottom: 20px;
            letter-spacing: -0.02em;
            background: linear-gradient(135deg, #ffffff 0%, #d1fae5 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        .what-header p {
            font-size: 18px;
            line-height: 1.7;
            color: rgba(255, 255, 255, 0.7);
            max-width: 600px;
        }

        /* Offer Split Layout */
        .offer-split {
            display: grid;
            grid-template-columns: 1fr 1.2fr;
            gap: 64px;
            align-items: flex-start;
        }

        /* Offer Index (Left Side) */
        .offer-index {
            display: flex;
            flex-direction: column;
            gap: 24px;
            position: sticky;
            top: 40px;
            align-self: flex-start;
        }

        .offer-link {
            all: unset;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px 30px;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 12px;
            color: rgba(255, 255, 255, 0.6);
            font-size: 18px;
            font-weight: 600;
            transition: all 0.3s ease;
            position: relative;
            border: 1px solid rgba(255, 255, 255, 0.08);
        }

        .offer-link::before {
            content: '';
            position: absolute;
            left: -24px;
            top: 50%;
            transform: translateY(-50%) scale(0);
            width: 8px;
            height: 8px;
            background: var(--green);
            border-radius: 50%;
            transition: transform 0.3s ease;
        }

        .offer-link span {
            font-size: 14px;
            letter-spacing: 0.12em;
            color: rgba(255, 255, 255, 0.25);
            text-transform: uppercase;
            font-weight: 600;
        }

        .offer-link:hover {
            color: rgba(255, 255, 255, 0.8);
            background: rgba(255, 255, 255, 0.08);
        }

        .offer-link.active {
            color: #fff;
            transform: translateX(12px);
            background: rgba(126, 211, 33, 0.15);
            border-color: rgba(126, 211, 33, 0.3);
        }

        .offer-link.active::before {
            transform: translateY(-50%) scale(1);
        }

        /* Offer Detail (Right Side) */
        .offer-detail {
            position: relative;
            min-height: 400px;
        }

        /* Overlapping Scroll Panels */
        .offer-panel {
            padding: 44px 44px 48px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2),
                inset 0 1px 0 rgba(255, 255, 255, 0.04);
            border-radius: 16px;
            border: 1px solid rgba(255, 255, 255, 0.05);
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            opacity: 0;
            visibility: hidden;
            transform: translateY(30px) scale(0.95);
            transition: opacity 0.5s ease, transform 0.5s ease, visibility 0.5s ease, box-shadow 0.5s ease;
            will-change: opacity, transform;
            backdrop-filter: blur(10px);
            z-index: 1;
        }

        .offer-panel.active {
            opacity: 1;
            visibility: visible;
            transform: translateY(0) scale(1);
            z-index: 10;
            background: linear-gradient(180deg,
                    rgba(28, 56, 84, 0.95) 0%,
                    rgba(18, 38, 60, 0.95) 100%);
            box-shadow: 0 50px 100px rgba(0, 0, 0, 0.4),
                inset 0 1px 0 rgba(255, 255, 255, 0.06);
        }

        .offer-panel h3 {
            font-size: 36px;
            font-weight: 800;
            color: #fff;
            margin-bottom: 20px;
            letter-spacing: -0.02em;
        }

        .offer-panel p {
            font-size: 18px;
            line-height: 1.7;
            color: rgba(255, 255, 255, 0.8);
            margin-bottom: 30px;
            max-width: 520px;
        }

        .detail-meta {
            display: flex;
            gap: 14px;
            margin-top: 32px;
            flex-wrap: wrap;
        }

        .detail-meta span {
            padding: 8px 20px;
            font-size: 14px;
            font-weight: 600;
            background: rgba(126, 211, 33, 0.08);
            border-radius: 999px;
            color: var(--green);
            display: inline-flex;
            align-items: center;
            gap: 8px;
        }

        .detail-meta span::before {
            content: '✓';
            color: var(--green);
            font-weight: 800;
        }

        /* Responsive Styles */
        @media (max-width: 1024px) {
            .offer-split {
                grid-template-columns: 1fr;
                gap: 40px;
            }

            .offer-index {
                position: static;
                flex-direction: row;
                overflow-x: auto;
                padding-bottom: 20px;
                margin-bottom: 20px;
                scrollbar-width: none;
            }

            .offer-index::-webkit-scrollbar {
                display: none;
            }

            .offer-link {
                white-space: nowrap;
                flex-shrink: 0;
            }

            /* Hide amount spans in mobile/tablet view */
            .offer-link span {
                display: none;
            }

            .offer-panel {
                padding: 40px 30px;
            }
        }

        @media (max-width: 768px) {
            .what-we-do {
                padding: 60px 6vw 40px;
            }

            .what-header h2 {
                font-size: 36px;
            }

            .offer-index {
                gap: 16px;
            }

            .offer-link {
                min-width: 200px;
                padding: 18px 24px;
                font-size: 16px;
            }

            .offer-panel h3 {
                font-size: 28px;
            }

            .offer-panel p {
                font-size: 16px;
            }

            /* Hide amount in detail-meta on mobile */
            .detail-meta span:first-child {
                display: none;
            }

            .detail-meta {
                gap: 10px;
            }

            .detail-meta span {
                padding: 6px 16px;
                font-size: 13px;
            }
        }

        @media (max-width: 480px) {
            .what-we-do {
                padding: 50px 5vw 30px;
            }

            .what-header h2 {
                font-size: 28px;
            }

            .eyebrow {
                font-size: 12px;
            }

            .offer-index {
                gap: 12px;
                padding-bottom: 16px;
            }

            .offer-link {
                min-width: 240px;
                padding: 16px 20px;
                font-size: 15px;
                flex-direction: column;
                align-items: flex-start;
                gap: 6px;
            }

            .offer-link span {
                font-size: 12px;
                align-self: flex-end;
            }

            .offer-panel {
                padding: 30px 20px;
                margin-bottom: 30px;
            }

            .offer-panel h3 {
                font-size: 24px;
            }

            .offer-panel p {
                font-size: 15px;
            }
        }
`, "",{"version":3,"sources":["webpack://./src/components/WhatWeOffer.css"],"names":[],"mappings":"EAAE;YACU,SAAS;YACT,UAAU;YACV,sBAAsB;YACtB,gCAAgC;QACpC;;QAEA,0BAA0B;QAC1B;YACI,sBAAsB;YACtB,0EAA0E;YAC1E,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,YAAY;YACZ,WAAW;YACX,UAAU;QACd;;QAEA;YACI,iBAAiB;YACjB,YAAY;YACZ,kBAAkB;YAClB,UAAU;YACV,WAAW;QACf;;QAEA;YACI,mBAAmB;YACnB,gBAAgB;QACpB;;QAEA;YACI,qBAAqB;YACrB,eAAe;YACf,gBAAgB;YAChB,sBAAsB;YACtB,yBAAyB;YACzB,mBAAmB;YACnB,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,gBAAgB;YAChB,mBAAmB;YACnB,uBAAuB;YACvB,6DAA6D;YAC7D,6BAA6B;YAC7B,oCAAoC;YACpC,qBAAqB;QACzB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,+BAA+B;YAC/B,gBAAgB;QACpB;;QAEA,uBAAuB;QACvB;YACI,aAAa;YACb,gCAAgC;YAChC,SAAS;YACT,uBAAuB;QAC3B;;QAEA,4BAA4B;QAC5B;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;YACT,gBAAgB;YAChB,SAAS;YACT,sBAAsB;QAC1B;;QAEA;YACI,UAAU;YACV,eAAe;YACf,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,kBAAkB;YAClB,qCAAqC;YACrC,mBAAmB;YACnB,+BAA+B;YAC/B,eAAe;YACf,gBAAgB;YAChB,yBAAyB;YACzB,kBAAkB;YAClB,2CAA2C;QAC/C;;QAEA;YACI,WAAW;YACX,kBAAkB;YAClB,WAAW;YACX,QAAQ;YACR,oCAAoC;YACpC,UAAU;YACV,WAAW;YACX,wBAAwB;YACxB,kBAAkB;YAClB,+BAA+B;QACnC;;QAEA;YACI,eAAe;YACf,sBAAsB;YACtB,gCAAgC;YAChC,yBAAyB;YACzB,gBAAgB;QACpB;;QAEA;YACI,+BAA+B;YAC/B,qCAAqC;QACzC;;QAEA;YACI,WAAW;YACX,2BAA2B;YAC3B,oCAAoC;YACpC,qCAAqC;QACzC;;QAEA;YACI,oCAAoC;QACxC;;QAEA,8BAA8B;QAC9B;YACI,kBAAkB;YAClB,iBAAiB;QACrB;;QAEA,8BAA8B;QAC9B;YACI,uBAAuB;YACvB;uDAC2C;YAC3C,mBAAmB;YACnB,2CAA2C;YAC3C,kBAAkB;YAClB,MAAM;YACN,OAAO;YACP,QAAQ;YACR,UAAU;YACV,kBAAkB;YAClB,uCAAuC;YACvC,8FAA8F;YAC9F,+BAA+B;YAC/B,2BAA2B;YAC3B,UAAU;QACd;;QAEA;YACI,UAAU;YACV,mBAAmB;YACnB,iCAAiC;YACjC,WAAW;YACX;;gDAEoC;YACpC;uDAC2C;QAC/C;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,WAAW;YACX,mBAAmB;YACnB,uBAAuB;QAC3B;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,+BAA+B;YAC/B,mBAAmB;YACnB,gBAAgB;QACpB;;QAEA;YACI,aAAa;YACb,SAAS;YACT,gBAAgB;YAChB,eAAe;QACnB;;QAEA;YACI,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,oCAAoC;YACpC,oBAAoB;YACpB,mBAAmB;YACnB,oBAAoB;YACpB,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,YAAY;YACZ,mBAAmB;YACnB,gBAAgB;QACpB;;QAEA,sBAAsB;QACtB;YACI;gBACI,0BAA0B;gBAC1B,SAAS;YACb;;YAEA;gBACI,gBAAgB;gBAChB,mBAAmB;gBACnB,gBAAgB;gBAChB,oBAAoB;gBACpB,mBAAmB;gBACnB,qBAAqB;YACzB;;YAEA;gBACI,aAAa;YACjB;;YAEA;gBACI,mBAAmB;gBACnB,cAAc;YAClB;;YAEA,4CAA4C;YAC5C;gBACI,aAAa;YACjB;;YAEA;gBACI,kBAAkB;YACtB;QACJ;;QAEA;YACI;gBACI,sBAAsB;YAC1B;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,SAAS;YACb;;YAEA;gBACI,gBAAgB;gBAChB,kBAAkB;gBAClB,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA,yCAAyC;YACzC;gBACI,aAAa;YACjB;;YAEA;gBACI,SAAS;YACb;;YAEA;gBACI,iBAAiB;gBACjB,eAAe;YACnB;QACJ;;QAEA;YACI;gBACI,sBAAsB;YAC1B;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,SAAS;gBACT,oBAAoB;YACxB;;YAEA;gBACI,gBAAgB;gBAChB,kBAAkB;gBAClB,eAAe;gBACf,sBAAsB;gBACtB,uBAAuB;gBACvB,QAAQ;YACZ;;YAEA;gBACI,eAAe;gBACf,oBAAoB;YACxB;;YAEA;gBACI,kBAAkB;gBAClB,mBAAmB;YACvB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;QACJ","sourcesContent":["  * {\n            margin: 0;\n            padding: 0;\n            box-sizing: border-box;\n            font-family: 'Inter', sans-serif;\n        }\n\n        /* What We Offer Section */\n        .what-we-do {\n            padding: 80px 6vw 60px;\n            background: linear-gradient(180deg, #0f1e2e 0%, #16293f 50%, #0f1e2e 100%);\n            position: relative;\n            overflow: hidden;\n            min-height: 100vh;\n            height: 100%;\n            width: 100%;\n            z-index: 1;\n        }\n\n        .what-wrap {\n            max-width: 1200px;\n            margin: auto;\n            position: relative;\n            z-index: 1;\n            width: 100%;\n        }\n\n        .what-header {\n            margin-bottom: 60px;\n            max-width: 800px;\n        }\n\n        .eyebrow {\n            display: inline-block;\n            font-size: 14px;\n            font-weight: 700;\n            letter-spacing: 0.15em;\n            text-transform: uppercase;\n            color: var(--green);\n            margin-bottom: 16px;\n        }\n\n        .what-header h2 {\n            font-size: 48px;\n            font-weight: 800;\n            line-height: 1.2;\n            margin-bottom: 20px;\n            letter-spacing: -0.02em;\n            background: linear-gradient(135deg, #ffffff 0%, #d1fae5 100%);\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n            background-clip: text;\n        }\n\n        .what-header p {\n            font-size: 18px;\n            line-height: 1.7;\n            color: rgba(255, 255, 255, 0.7);\n            max-width: 600px;\n        }\n\n        /* Offer Split Layout */\n        .offer-split {\n            display: grid;\n            grid-template-columns: 1fr 1.2fr;\n            gap: 64px;\n            align-items: flex-start;\n        }\n\n        /* Offer Index (Left Side) */\n        .offer-index {\n            display: flex;\n            flex-direction: column;\n            gap: 24px;\n            position: sticky;\n            top: 40px;\n            align-self: flex-start;\n        }\n\n        .offer-link {\n            all: unset;\n            cursor: pointer;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding: 20px 30px;\n            background: rgba(255, 255, 255, 0.05);\n            border-radius: 12px;\n            color: rgba(255, 255, 255, 0.6);\n            font-size: 18px;\n            font-weight: 600;\n            transition: all 0.3s ease;\n            position: relative;\n            border: 1px solid rgba(255, 255, 255, 0.08);\n        }\n\n        .offer-link::before {\n            content: '';\n            position: absolute;\n            left: -24px;\n            top: 50%;\n            transform: translateY(-50%) scale(0);\n            width: 8px;\n            height: 8px;\n            background: var(--green);\n            border-radius: 50%;\n            transition: transform 0.3s ease;\n        }\n\n        .offer-link span {\n            font-size: 14px;\n            letter-spacing: 0.12em;\n            color: rgba(255, 255, 255, 0.25);\n            text-transform: uppercase;\n            font-weight: 600;\n        }\n\n        .offer-link:hover {\n            color: rgba(255, 255, 255, 0.8);\n            background: rgba(255, 255, 255, 0.08);\n        }\n\n        .offer-link.active {\n            color: #fff;\n            transform: translateX(12px);\n            background: rgba(126, 211, 33, 0.15);\n            border-color: rgba(126, 211, 33, 0.3);\n        }\n\n        .offer-link.active::before {\n            transform: translateY(-50%) scale(1);\n        }\n\n        /* Offer Detail (Right Side) */\n        .offer-detail {\n            position: relative;\n            min-height: 400px;\n        }\n\n        /* Overlapping Scroll Panels */\n        .offer-panel {\n            padding: 44px 44px 48px;\n            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2),\n                inset 0 1px 0 rgba(255, 255, 255, 0.04);\n            border-radius: 16px;\n            border: 1px solid rgba(255, 255, 255, 0.05);\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            opacity: 0;\n            visibility: hidden;\n            transform: translateY(30px) scale(0.95);\n            transition: opacity 0.5s ease, transform 0.5s ease, visibility 0.5s ease, box-shadow 0.5s ease;\n            will-change: opacity, transform;\n            backdrop-filter: blur(10px);\n            z-index: 1;\n        }\n\n        .offer-panel.active {\n            opacity: 1;\n            visibility: visible;\n            transform: translateY(0) scale(1);\n            z-index: 10;\n            background: linear-gradient(180deg,\n                    rgba(28, 56, 84, 0.95) 0%,\n                    rgba(18, 38, 60, 0.95) 100%);\n            box-shadow: 0 50px 100px rgba(0, 0, 0, 0.4),\n                inset 0 1px 0 rgba(255, 255, 255, 0.06);\n        }\n\n        .offer-panel h3 {\n            font-size: 36px;\n            font-weight: 800;\n            color: #fff;\n            margin-bottom: 20px;\n            letter-spacing: -0.02em;\n        }\n\n        .offer-panel p {\n            font-size: 18px;\n            line-height: 1.7;\n            color: rgba(255, 255, 255, 0.8);\n            margin-bottom: 30px;\n            max-width: 520px;\n        }\n\n        .detail-meta {\n            display: flex;\n            gap: 14px;\n            margin-top: 32px;\n            flex-wrap: wrap;\n        }\n\n        .detail-meta span {\n            padding: 8px 20px;\n            font-size: 14px;\n            font-weight: 600;\n            background: rgba(126, 211, 33, 0.08);\n            border-radius: 999px;\n            color: var(--green);\n            display: inline-flex;\n            align-items: center;\n            gap: 8px;\n        }\n\n        .detail-meta span::before {\n            content: '✓';\n            color: var(--green);\n            font-weight: 800;\n        }\n\n        /* Responsive Styles */\n        @media (max-width: 1024px) {\n            .offer-split {\n                grid-template-columns: 1fr;\n                gap: 40px;\n            }\n\n            .offer-index {\n                position: static;\n                flex-direction: row;\n                overflow-x: auto;\n                padding-bottom: 20px;\n                margin-bottom: 20px;\n                scrollbar-width: none;\n            }\n\n            .offer-index::-webkit-scrollbar {\n                display: none;\n            }\n\n            .offer-link {\n                white-space: nowrap;\n                flex-shrink: 0;\n            }\n\n            /* Hide amount spans in mobile/tablet view */\n            .offer-link span {\n                display: none;\n            }\n\n            .offer-panel {\n                padding: 40px 30px;\n            }\n        }\n\n        @media (max-width: 768px) {\n            .what-we-do {\n                padding: 60px 6vw 40px;\n            }\n\n            .what-header h2 {\n                font-size: 36px;\n            }\n\n            .offer-index {\n                gap: 16px;\n            }\n\n            .offer-link {\n                min-width: 200px;\n                padding: 18px 24px;\n                font-size: 16px;\n            }\n\n            .offer-panel h3 {\n                font-size: 28px;\n            }\n\n            .offer-panel p {\n                font-size: 16px;\n            }\n\n            /* Hide amount in detail-meta on mobile */\n            .detail-meta span:first-child {\n                display: none;\n            }\n\n            .detail-meta {\n                gap: 10px;\n            }\n\n            .detail-meta span {\n                padding: 6px 16px;\n                font-size: 13px;\n            }\n        }\n\n        @media (max-width: 480px) {\n            .what-we-do {\n                padding: 50px 5vw 30px;\n            }\n\n            .what-header h2 {\n                font-size: 28px;\n            }\n\n            .eyebrow {\n                font-size: 12px;\n            }\n\n            .offer-index {\n                gap: 12px;\n                padding-bottom: 16px;\n            }\n\n            .offer-link {\n                min-width: 240px;\n                padding: 16px 20px;\n                font-size: 15px;\n                flex-direction: column;\n                align-items: flex-start;\n                gap: 6px;\n            }\n\n            .offer-link span {\n                font-size: 12px;\n                align-self: flex-end;\n            }\n\n            .offer-panel {\n                padding: 30px 20px;\n                margin-bottom: 30px;\n            }\n\n            .offer-panel h3 {\n                font-size: 24px;\n            }\n\n            .offer-panel p {\n                font-size: 15px;\n            }\n        }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
